import formatCalendarDay from './formatCalendarDay';
import formatClockTime from './formatClockTime';

/**
 * Format a session-gap divider label for the chat transcript — the date stamp
 * that sits centered on the rule drawn above the first message of a new session.
 *
 * Pairs a calendar-relative day with a lowercase clock time:
 *
 * | when                     | example                  |
 * | ------------------------ | ------------------------ |
 * | today                    | `Today at 3:20 pm`       |
 * | yesterday                | `Yesterday at 3:20 pm`   |
 * | 2–6 days ago (this week) | `Friday at 3:20 pm`      |
 * | 7+ days ago              | `May 23 at 3:20 pm`      |
 * | 7+ days, different year  | `May 23, 2024 at 3:20 pm`|
 *
 * Day buckets are computed from local-midnight boundaries, so the today/
 * yesterday label is stable across re-renders within the same day rather than
 * flipping on a rolling 24h window. `now` is injectable for deterministic tests.
 */
export default function formatSessionDivider(date: Date, now: Date = new Date()): string {
  return `${formatCalendarDay(date, now)} at ${formatClockTime(date)}`;
}
